import { observable, action } from 'mobx';

class CompareStore {
  @observable hasDifferentData = false;

  @observable idMap: { [key: string]: string } = {};

  @observable isInitSessionSuccess: boolean | undefined;

  @action
  updateIsInitSessionSuccess(isInitSessionSuccess: boolean) {
    this.isInitSessionSuccess = isInitSessionSuccess;
  }

  @action
  updateHasDifferentData(hasDifferentData: boolean) {
    this.hasDifferentData = hasDifferentData;
  }

  @action
  updateIDMap(data: { [key: string]: string }) {
    this.idMap = {
      ...this.idMap,
      ...data,
    };
  }

  @action
  recoverCompareData({ hasDifferentData, idMap, isInitSessionSuccess }: CompareStore) {
    this.updateIsInitSessionSuccess(isInitSessionSuccess || false);
    this.updateHasDifferentData(hasDifferentData);
    this.updateIDMap(idMap);
  }
}

const compareStore = new CompareStore();

export default compareStore;
